export default __webpack_public_path__ + "static/media/google.766cdef6.svg";